import React, { Component } from 'react';
import {
    Card, CardBody, Pagination
} from 'reactstrap';
import { Link } from 'react-router-dom';
import {
    FaFile,
    FaFileAlt,
    FaFileSignature,
    FaChartLine
} from 'react-icons/fa';
import  BootstrapTable  from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import appConfig from '../../config/config';
import axios from "axios";







function downloadDoc(d) {
    axios.post(
        appConfig.apiGateway.getDocUrl,
        JSON.stringify({ Action: "File", DOC_ID: d }, null, 2),
        {
            headers :
            {
                'Content-Type': 'application/json',
                //'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
            }
        }
        ).then((response) => {
            console.log(response)
            const url = response.data.body.dlink;
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.pdf');
            document.body.appendChild(link);
            link.click();   
            });
        }
        
        
        class OrderGrid extends Component {
            state = { id:null, display:false }
            constructor(props) {
                super(props);
                this.d = props.orders;
            }
            editOrder(cell, row) {
                return (
                    <Link to={{ pathname: "/order-edit", Order: {Id : row.ID, tab:'1'}}}>{cell}</Link>
                    );
            }
            addOrderNote = (cell, row) => {
                return (
                    <Link to={{ pathname: "/order-search/addnote", OrderId: row.ID}}>{cell}</Link>
                    );
            }
            editOrderPeoduct  (cell, row){
                return (
                    <Link to={{ pathname: "/order-edit", Order: {Id : row.ID, tab:'2'}}}>{cell}</Link>
                    );
            }
            orderAction=(cell, row)=> {
        this.setState({id:cell});
        return (
                <>
                {/* {(row.PRODUCT != 'Two Owner') && (<Link to={{ pathname: "/property-report", 
                        Order: { Id: row.ID, OrderProductId: row.ORDER_PRODUCTID } }}><FaFile /></Link>)} */}
                {(row.DOC_ID > 0) && (<Link onClick={() => { 
                    this.setState({id:row.ID,display:true})
                    downloadDoc(row.DOC_ID) 
                    }}><FaFile />{row.filedescript}</Link>)}
                </>
        );
        //<span onClick={this.saveDataToLocalStorage(post.id)}><FaFile /></span>>
    }
    orderColumns = [
        {
        dataField: 'ID',
        text: 'ID',
        sort: true,
        formatter: this.editOrder,
        hidden: true
        },
        {
        dataField: 'KEY',
        text: 'KEY',
        sort: true,
        hidden: true
        },
        {
        dataField: 'SYSTEMORDERID',
        text: 'Order #',
            sort: true ,
            formatter: this.editOrder,
        },
        {
        dataField: 'STATUS',
        text: 'Status',
            sort: true 
        },
        {
            dataField: 'CREATEDUSERNAME',
            text: 'User',
            sort: true
            },
        {
        dataField: 'CREATEDDATE',
        text: 'Ordered Date',
            sort: true //,
            //formatter: editOrder,
        },
    
        {
        dataField: 'LOANID',
        text: 'Loan #',
            sort: true //,
        },
        {
        dataField: 'LOS',
        text: 'LOS',
            sort: true //,
        },
        {
        dataField: 'LOSID',
        text: 'LOS ID',
            sort: true //, formatter: this.addOrderNote

        },
        {
            dataField: 'PRODUCT',
            text: 'Product',
            sort: true, formatter: this.editOrderPeoduct
        },
        {
        dataField: 'ADDRESS_LINE',
        text: 'Address',
        sort: true
        },

        {
        dataField: 'CITY',
        text: 'City',
        sort: true
        },
        {
            dataField: 'ORDER_PRODUCTID',
            text: 'PRODUCTID',
            hidden: true
        },
        {
            dataField: 'DOC_ID',
            text: 'DOC_ID',
            hidden: true
        },
        {
            text: 'Action',
            formatter: this.orderAction
        }
    ];
    
    
     d = []



    render() {
        return (
            <Card className="w-100">
                <CardBody>
                    <BootstrapTable
                        striped
                        data={this.props.orders}
                        columns={this.orderColumns}
                        keyField="KEY"
                        pagination={paginationFactory()}
                    />
                </CardBody>
            </Card>
        );
    }
}

export default OrderGrid;